import React, { FC } from "react";
import classNames from "classnames";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { IRichText, TextType } from "@app/models/storyblok/basic";

type Props = {
  data: IRichText<TextType>;
};

export const Body: FC<Props> = ({ data }) => (
  <article
    className={classNames(
      "prose leading-[1.75rem] text-base-400 prose-headings:text-medium-large prose-headings:text-primary-content prose-a:text-base-400 prose-a:underline hover:prose-a:text-primary-content prose-li:marker:text-base-400",
      "md:mx-auto md:max-w-container-small",
    )}
  >
    <BlockBody richText={data} />
  </article>
);
